import gql from 'graphql-tag'

export const LOGIN_QUERY = gql`
  query ($account: String!, $password: String!) {
    login(account: $account, password: $password) {
      accessToken
      refreshToken
    }
  }
`

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ($password: String!, $new_password: String!) {
    changePassword(password: $password, new_password: $new_password) {
      accessToken
      refreshToken
    }
  }
`

// Never select `password` here.
export const GET_USERS_QUERY = gql`
  query ($limit: Int = 10, $offset: Int = 0) {
    user(order_by: { created_at: desc }, limit: $limit, offset: $offset) {
      account
      role
      disabled
      created_at
      user_audiences {
        audience_id
        audience {
          name
        }
      }
    }
    user_aggregate {
      aggregate {
        count
      }
    }
  }
`

export const CREATE_USER_MUTATION = gql`
  mutation ($user: CreateUserInput!) {
    createUser(user: $user) {
      success
    }
  }
`

export const SET_USER_PASSWORD_MUTATION = gql`
  mutation ($account: String!, $password: String!) {
    setUserPassword(account: $account, password: $password) {
      success
    }
  }
`

export const SET_USER_DISABLED_MUTATION = gql`
  mutation ($account: String!, $disabled: Boolean!) {
    setUserDisabled(account: $account, disabled: $disabled) {
      account
      disabled
    }
  }
`

export const GET_ALL_CAMPAIGNS_QUERY = gql`
  query {
    audience(order_by: { name: asc }) {
      id
      name
    }
  }
`

export const SET_USER_CAMPAIGNS_MUTATION = gql`
  mutation (
    $account: String!
    $keep: [uuid!]!
    $objects: [user_audience_insert_input!]!
  ) {
    delete_user_audience(
      where: { account: { _eq: $account }, audience_id: { _nin: $keep } }
    ) {
      affected_rows
    }
    insert_user_audience(
      objects: $objects
      on_conflict: { constraint: user_audience_pkey, update_columns: [] }
    ) {
      affected_rows
    }
  }
`
